export default {
  meta: {
    title: '点位测评-本品牌门店',
    url: '/spotevaluation/clusterstores', // 埋点字段，上报归属的模块
    urlName: '点位测评' // 埋点字段，上报归属的模块
  }
};
